import { formatDate } from './dateHelpers'

export const transformInvoices = invoices => {
    const sortedInvoices = invoices.sort((a, b) => (a.date > b.date ? -1 : a.date < b.date ? 1 : 0))

    const invoicesByDates = {}
    const invoicesWithMonthHeadings = []
    sortedInvoices.map((el, index, arr) => {
        const currentElDate = el.date
        const nextElDate = arr[index + 1] ? arr[index + 1].date : undefined

        if (!invoicesByDates[currentElDate]) {
            invoicesByDates[currentElDate] = []
        }
        invoicesByDates[currentElDate] = [...invoicesByDates[currentElDate], el]

        const OPTIONS = { month: 'short', year: 'numeric' }
        if (index === 0) {
            invoicesWithMonthHeadings.push({
                startMonthSection: true,
                monthHeading: formatDate(currentElDate, OPTIONS),
                date: currentElDate,
            })
        }
        if (currentElDate > nextElDate) {
            invoicesWithMonthHeadings.push(el)
            invoicesWithMonthHeadings.push({
                startMonthSection: true,
                monthHeading: formatDate(nextElDate, OPTIONS),
                date: nextElDate,
            })
        } else {
            invoicesWithMonthHeadings.push(el)
        }
    })
    return { invoicesByDates, invoicesWithMonthHeadings }
}
